export const UPDATE_GRADE_CATALOG_TAB = 'UPDATE_GRADE_CATALOG_TAB';
export const UPDATE_CUSTOM_GRADES_TAB = 'UPDATE_CUSTOM_GRADES_TAB'
